import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductService } from '../../services/product.service';
import { ToastService } from '../../toast.service';

@Component({
  selector: 'app-product-form',
  templateUrl: './product-form.component.html',
  styleUrl: './product-form.component.css'
})
export class ProductFormComponent implements OnInit {
  productForm!: FormGroup;
  productId: number | null = null;
  imageFile: File | null = null;
  previewUrl: string | null = null;
  isEditMode = false;
  //categories: any[] = [];
  name: string = '';
  description: string = '';
  price: number = 0;
  specification: string = '';
  categoryIdFromTree: number | null = null;

  constructor(
    private fb: FormBuilder,
    private productService: ProductService,
    private route: ActivatedRoute,
    private router: Router,
    private toast: ToastService
  ) { }

  ngOnInit(): void {
    this.productId = +this.route.snapshot.paramMap.get('id')!;
    this.isEditMode = !!this.productId;

    this.route.queryParams.subscribe(params => {
      if (params['categoryId']) {
        this.categoryIdFromTree = +params['categoryId'];
      }
    });

    //this.loadCategories();
    this.productForm = this.fb.group({
      categoryId: ['', Validators.required], // hidden
      name: ['', Validators.required],
      description: [''],
      specification: [''],
      sizes: [''],
      sizeChart: this.fb.array([]),
      price: [0, [Validators.required, Validators.min(0)]],
      imagePath: [''],
    });

    // Initialize with one row (optional)
    this.addSizeChartEntry();

    if (this.isEditMode) {
      this.loadProduct();
    }
  }

  get sizeChart(): FormArray {
    return this.productForm.get('sizeChart') as FormArray;
  }

  loadProduct() {
    this.productService.getProductById(this.productId!).subscribe({
      next: (product) => {
        this.productForm.patchValue(product);
        this.previewUrl = product.imagePath;
      },
      error: (err) => console.error('Error loading product', err),
    });
  }

  onImageChange(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.imageFile = file;

      const reader = new FileReader();
      reader.onload = () => (this.previewUrl = reader.result as string);
      reader.readAsDataURL(file);
    }
  }

  sizes = [{ size: 'M' }, { size: 'L' }, { size: 'XL' }, { size: 'XXL' }];

  selectedSizes: string[] = [];

  categories: any[] = [
    { id: 1, name: 'Men' },
    { id: 2, name: 'Women' },
    { id: 3, name: 'Kids' },
  ];

  selectedCategoryId: number | null = null;


  removeSizeChartEntry(index: number): void {
    this.sizeChart.removeAt(index);
  }

  addSizeChartEntry(): void {
    const sizeGroup = this.fb.group({
      size: ['', Validators.required],
      chest: [0, Validators.required],
      length: [0, Validators.required],
      sleeve: [0, Validators.required]
    });

    this.sizeChart.push(sizeGroup);
  }


  
  onSizeChange(event: any, size: string) {
    if (event.target.checked) {
      this.selectedSizes.push(size);
    } else {
      this.selectedSizes = this.selectedSizes.filter(s => s !== size);
    }
  }


  saveProduct() {
    // Update form value
    this.productForm.patchValue({
      sizes: this.selectedSizes
    });

    this.productForm.patchValue({
      categoryId: this.categoryIdFromTree
    });

    const formData = new FormData();
    formData.append('categoryId', this.productForm.value.categoryId);
    formData.append('name', this.productForm.value.name);
    formData.append('description', this.productForm.value.description);
    formData.append('specification', this.productForm.value.specification);
    formData.append('sizes', JSON.stringify(this.productForm.value.sizes));
    formData.append('sizeChart', JSON.stringify(this.productForm.value.sizeChart));
    formData.append('price', this.productForm.value.price);
    if (this.imageFile) formData.append('imageFile', this.imageFile);

    console.log('Saving product:', formData);
    // Call your backend API here
    if (this.isEditMode) {
      this.productService.updateProductById(this.productId!, formData).subscribe(() => {
        this.router.navigate(['/product']);
      });
    } else {
      this.productService.addProduct(formData).subscribe({
        next: (response) => {
          this.router.navigate(['/product']);
          this.toast.show(response.message , 'success');
        },
        error: (err) => {
          console.error('Error creating product:', err)
          this.toast.show(err.error?.message || 'Something went wrong', 'error');
        }
      });
    }
  }
}
